import type { PlotGeoResponse } from "api/model";
import type { ImageCornerCoordinates } from "context/CogOrtho/orthoAssets";
import {
  hasBoundaryGeoJson,
  isPointInOrOnPolygon,
} from "context/PlotMap/boundaryUtils";
import type { BoundaryPoint, LngLatRing } from "context/PlotMap/geo";

/** Vertices from every plot exterior ring that has geometry. */
export const getPlotGeometryPoints = (
  plots: readonly PlotGeoResponse[],
): BoundaryPoint[] => {
  const points: BoundaryPoint[] = [];

  for (const plot of plots) {
    if (plot.boundary == null || !hasBoundaryGeoJson(plot.boundary)) {
      continue;
    }

    for (const polygon of plot.boundary.coordinates) {
      const exterior = polygon[0];
      if (exterior == null) {
        continue;
      }

      for (const position of exterior) {
        const longitude = position[0];
        const latitude = position[1];
        if (longitude == null || latitude == null) {
          continue;
        }
        points.push({ latitude, longitude });
      }
    }
  }

  return points;
};

/**
 * True when every plot-geometry vertex lies inside or on the ortho footprint
 * ring (ortho and plots may be rotated; not axis-aligned).
 */
export const doesOrthoEnclosePlotGeometry = (
  orthoCoordinates: ImageCornerCoordinates,
  plots: readonly PlotGeoResponse[],
): boolean => {
  const points = getPlotGeometryPoints(plots);
  if (points.length === 0) {
    return false;
  }

  const orthoRing: LngLatRing = orthoCoordinates;
  return points.every((point) => isPointInOrOnPolygon(point, orthoRing));
};
